import { useSticky } from '@/hooks/use-sticky';
import { useGetNavbarHeight } from '@/queries/layout.queries';
import { useBreakpointValue } from '@cmpsr/components';
import { ReactNode } from 'react';
import { useSearchParams } from 'react-router-dom';
import useTestingPlanController from '../your-testing-plan/your-testing-plan.controller';

type TabTypes = 'to-do' | 'completed';
export type TabLiteralsType = Record<TabTypes, { name: string; component: ReactNode }>;

export const useTestingPlanTabsController = () => {
  const isFitted = useBreakpointValue({ base: true, lg: false }, { ssr: false });
  const { data: navBarSize } = useGetNavbarHeight();
  const { toDoCount, completedCount } = useTestingPlanController();
  const { ref, isSticky } = useSticky(navBarSize);
  const [params, setParams] = useSearchParams();
  const selectedTabIndex = params.get('tab') === 'completed' ? 1 : 0;

  const getItemCount = (tabKey: TabTypes) => {
    switch (tabKey) {
      case 'to-do':
        return toDoCount;
      case 'completed':
        return completedCount;
    }
  };

  const handleTabChange = (index: number) => {
    const tabValue = index === 1 ? 'completed' : 'to-do';
    setParams({ tab: tabValue });
  };

  return {
    isFitted,
    navBarSize,
    ref,
    isSticky,
    selectedTabIndex,
    getItemCount,
    handleTabChange,
  };
};
